/**
 * Multi-mission catalog for the menu shell.
 * Each mission is a lazy-loaded entry point; physics packs stay mission-local.
 */

export type MissionId = "to-the-moon" | "flight-13" | "flight-14";

export type MissionStatus = "ready" | "preview";

export type MissionDef = {
  id: MissionId;
  title: string;
  subtitle: string;
  blurb: string;
  status: MissionStatus;
  /** Hash path segment: `#/mission/<path>` (`?t=` seeks the clock) */
  path: string;
};

export const MISSIONS: readonly MissionDef[] = [
  {
    id: "flight-13",
    title: "Starship Flight 13",
    subtitle: "July 2026 · Starbase · flight test · true scale",
    blurb:
      "Full theater: staged ascent, hot-stage, suborbital coast, Raptor relight, " +
      "entry, Indian Ocean splashdown, and a sea-level drone hold of the floating " +
      "ship through T+1:10. Same visual stack as the lunar mission (pad, craft, cameras, HUD).",
    status: "ready",
    path: "flight-13",
  },
  {
    id: "flight-14",
    title: "Starship Flight 14",
    subtitle: "28 Sep 2026 · Starbase OLP-2 · first orbital flight",
    blurb:
      "Full theater: staged ascent, hot-stage, Gulf booster recovery, single-Raptor " +
      "insertion near 275 km, 26 Starlink V3, deorbit, Pacific splashdown, and a " +
      "sea-level drone hold of the floating ship. Same visual stack as Flight 13.",
    status: "ready",
    path: "flight-14",
  },
  {
    id: "to-the-moon",
    title: "Starbase → Moon",
    subtitle: "July 2027 · Boca Chica · true scale",
    blurb:
      "Interactive theater: staged ascent from Starbase, low Earth orbit dogleg, " +
      "translunar injection, ballistic n-body coast, and lunar arrival.",
    status: "ready",
    path: "to-the-moon",
  },
] as const;

export function missionById(id: string): MissionDef | undefined {
  return MISSIONS.find((m) => m.id === id || m.path === id);
}

export function missionByPath(path: string): MissionDef | undefined {
  return MISSIONS.find((m) => m.path === path || m.id === path);
}
